import React, { FC, useEffect } from "react";
import { PostAuthorType } from "data/types";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Avatar from "componentsTemplate/Avatar/Avatar";
import NcImage from "componentsTemplate/NcImage/NcImage";
import Link from "componentsTemplate/Link";

export interface CardCategoryProps {
  className?: string;
  data: any;
}

const CardCategory: FC<CardCategoryProps> = ({ className = "", data }) => {
  const { displayName, href = "/", avatar, jobName, count, bgImage } = data;
  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  return (
    <Link
      href={'dicas/'+data?.id}
      className={`nc-CardAuthorBox2 flex flex-col overflow-hidden bg-white dark:bg-neutral-800 rounded-3xl ${className}`}
      style={{ height: "285px" }}
    >
      <div className="relative flex-shrink-0 ">
        <div>
          <NcImage
            alt="author"
            containerClassName="flex aspect-w-7 aspect-h-5 w-full h-0"
            src={
              urlBase +
              "/storage/images/categories/banners/" +
              data?.banner_path
            }
            fill
            sizes="(max-width: 600px) 480px, 33vw"
          />
        </div>
        {/* <div className="absolute top-3 inset-x-3 flex">
          <div className=" py-1 px-4 bg-neutral-100 dark:bg-neutral-800 rounded-full flex items-center justify-center leading-none text-xs font-medium">
            {count} <ArrowRightIcon className="w-5 h-5 text-yellow-600 ml-3" />
          </div>
        </div> */}
      </div>

      <div className="-mt-8 m-8 text-center">
        <Avatar
          containerClassName="ring-2 ring-white bg-primary-300 text-primary-300"
          sizeClass="w-20 h-20 text-2xl"
          radius="rounded-full"
          imgUrl={
            urlBase + "/storage/images/categories/icons/" + data?.icon_path
          }
          userName={data?.name}
        />
        <div className="mt-3">
          <h2 className={`text-base font-semibold`}>
            <span className=" mt-2 text-primary-600 w-100">{data?.name}</span>
          </h2>
          <span
            className={`block mt-1 text-sm text-primary-6000 dark:text-neutral-400 truncate h-5`}
          >
            {data?.subtitle}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CardCategory;
